import { getContractorComments, getContractors } from "api/queries/contractors/contractor";
import { UseInfiniteQueryOptions, UseInfiniteQueryResult, UseQueryResult, useInfiniteQuery, useQuery } from "react-query";
import { IGetCommentsResponse } from "rules/interface/api/comments/get-comments.interface";
import { IError } from "rules/interface/api/error.interface";
import { IApiRequestPagination, IOptionsParams, IServerGetResponse } from "rules/interface/api/response";
import { IContractor } from "rules/interface/contractor/contractor.interface";
import IContractorListMeta from "rules/interface/contractor/list-meta.interface";
import IContractorListParams from "rules/interface/contractor/list-params.interface";



interface IGetContractorsParams {
    params?: IContractorListParams & IApiRequestPagination
    options?: UseInfiniteQueryOptions<IServerGetResponse<IContractor[]>, IError>
}

export const useGetContractors = (params: IGetContractorsParams): UseInfiniteQueryResult<IServerGetResponse<IContractor[], IContractorListMeta>, IError> => {
    let filters = null

    if (typeof window !== "undefined") {
        filters = new URLSearchParams(location.search)
    }

    return useInfiniteQuery(
        ["getContractors", params, typeof window !== "undefined" && location],
        ({ pageParam = 1 }) =>
            getContractors({ params: { ...params?.params, ...(filters && { ...JSON.parse(filters.get("filters")) }), page: pageParam } }),
        {
            getNextPageParam: (lastPage) => {
                const { page, count } = lastPage?.meta;
                return ((page * (params.params?.limit ?? 10)) <= count) ? (page + 1) : undefined;
            },
            ...params?.options
        },
    );
}

export const useGetContractorsPagination = (params: IOptionsParams<IContractorListParams & IApiRequestPagination, IServerGetResponse<IContractor[]>>) => {
    return useQuery(
        ["getContractors", params],
        () =>
            getContractors(params), {
                ...params.options
            }
    );
}

interface IProps {
    params: {
        limit?: number
        fiveGen?: boolean
        contractorId?: string
        assemblerId?: string
        profileId?: string
    }
    options?: UseInfiniteQueryOptions<IServerGetResponse<IGetCommentsResponse[]>, IError>
}

export const useGetContractorComments = ({ params, options }: IProps): UseInfiniteQueryResult<IServerGetResponse<IGetCommentsResponse[]>> => {
    return useInfiniteQuery(
        ["getContractorComments", params, options],
        ({ pageParam = 1 }) =>
            getContractorComments({ params: { ...params, page: pageParam } }),
        {
            ...options,
            getNextPageParam: lastPage => {
                const { page, count } = lastPage.meta;
                return ((page * (params?.limit ?? 10)) < count) ? (page + 1) : undefined;
            },
        },
    );
};